// Generated by purs version 0.15.15
import * as Ouroboros_Programs_Capabilities from "../Ouroboros.Programs.Capabilities/index.js";
import * as Ouroboros_Programs_Controllers_DocumentRefine from "../Ouroboros.Programs.Controllers.DocumentRefine/index.js";
var readOption = function (v) {
    return v;
};
var mkDocumentRefineEnv = function (input) {
    return {
        loading: input.kernel.loading,
        navigate: input.kernel.navigate,
        reviewRoute: input.kernel.reviewRoute,
        document: input.kernel.document,
        mostRecentSection: input.kernel.mostRecentSection,
        updateSection: input.kernel.updateSection,
        refineSection: input.kernel.refineSection,
        taskRunner: input.kernel.taskRunner
    };
};
var buildDocumentRefineViewProps = function (input) {
    var controller = Ouroboros_Programs_Controllers_DocumentRefine.mkDocumentRefineController(mkDocumentRefineEnv(input));
    return {
        mostRecentSection: readOption(Ouroboros_Programs_Capabilities.optionStateHandleRead(input.kernel.mostRecentSection)),
        onSubmit: function (feedback) {
            return Ouroboros_Programs_Controllers_DocumentRefine.runDocumentRefineAction(controller.submit(feedback));
        }
    };
};
export {
    buildDocumentRefineViewProps
};
//# sourceMappingURL=index.js.map
